// Single source of truth for the standard (house) prices of the optional Life
// Study extensions. Consumed by BOTH the Extensions Invoice presets and the
// Extensions Prospectus defaults, so the two documents can never disagree.
// The Documentary is a "from" floor, confirmed once the shoot is scoped.
export const EXTENSION_PRICES = {
  documentary: "R220,000",
  sonic: "R70,000",
  vault: "R45,000",
  allThree: "R335,000",
};
